module.exports = __webpack_public_path__ + "resources/img/ico-compnay-patent-list@2x.923709d4.png";